/** How a matter's status reads to a guest. */
const LABELS = {
  open: 'Open',
  pending: 'Pending',
  closed: 'Closed',
  archived: 'Closed',
};

export const statusLabel = (status) => LABELS[status] ?? 'Open';
